import dayjs from "utils/dates/dayjsex";

export default function formatTransactionTimestamp(timestamp: string): string {
  const date = dayjs(timestamp);
  return date.format("MMM D, YYYY [at] h:mma");
}
